import React, { Component } from 'react';
import VR2_Forms from '../../pages/VR2_Form_Rendering/displayContainer';

export class PMReport extends Component {
  render() {
    return (
      <VR2_Forms
      screenName = 'PM_Screen'
      screenAction = 'create'
      />
    )
  }
}

export default PMReport